export default "__VITE_ASSET__582c482c__"